const CONNECTION_REFUSED_PATTERN = /ECONNREFUSED|could not proxy request/i;

const wait = delayMs =>
  new Promise(resolve => {
    setTimeout(resolve, delayMs);
  });

export const isConnectionRefusedError = error => {
  const responseData = error?.response?.data;
  const responseMessage =
    typeof responseData === 'string'
      ? responseData
      : responseData?.detail || responseData?.error;

  return [
    error?.code,
    error?.message,
    responseMessage,
    error?.request?.responseText,
  ].some(value => CONNECTION_REFUSED_PATTERN.test(String(value || '')));
};

export const withConnectionRefusedRetry = async (
  request,
  { delayMs = 1000, waitForRetry = wait } = {}
) => {
  try {
    return await request();
  } catch (error) {
    if (!isConnectionRefusedError(error)) throw error;
    await waitForRetry(delayMs);
    return request();
  }
};
